module.exports = __webpack_public_path__ + "assets/202509252035/img/Chris.2ed5258f.jpg";